import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

if (window.screen.availWidth >= 768) {
  ScrollTrigger.create({
    trigger: ".mv-gds-image",
    pin: true,
    scrub: 1,
    pinSpacing: false,
    start: 50,
    end: "+=450",
  });
}
